import PropTypes from "prop-types";
import React from "react";
import ControlButton from "ControlButton";

export default class CloseButton extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
  };

  render() {
    return (
      <ControlButton
        className="close-button icon-Close2 font-size--copy--small"
        onClick={this.props.onClick}
      />
    );
  }
}
